import React, { useState, useEffect } from 'react';
import { tippspielAPI } from '../services/api';
import { EVALUATION_LABELS, REASON_LABELS } from '../utils/tipLabels';
import PageHeader from '../components/PageHeader';

const TippspielMyTips = () => {
  const [tips, setTips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    tippspielAPI.getMyTips()
      .then((res) => setTips(res.data || []))
      .catch((err) => setError(err.response?.data?.message || 'Tipps konnten nicht geladen werden.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-24">
        <span className="loading loading-spinner loading-lg text-primary" />
      </div>
    );
  }

  const totalPoints = tips.reduce((sum, t) => sum + (t.points || 0), 0);

  return (
    <div className="space-y-8">
      <PageHeader
        kicker="Tippspiel"
        title="Meine Tipps"
        subtitle={`${tips.length} Tipps abgegeben`}
        actions={<div className="score-badge">{totalPoints} Pkt.</div>}
      />

      {error && <div className="alert-error-dark">{error}</div>}

      <div className="t12-table-wrap overflow-x-auto">
        <table className="t12-table min-w-[640px]">
          <thead>
            <tr>
              <th>Spiel</th>
              <th>Tipp</th>
              <th>Ergebnis</th>
              <th className="text-right">Pkt.</th>
              <th className="hidden sm:table-cell">Art</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {tips.map((t) => {
              const m = t.matchId;
              const result = m?.resultRegular;
              const reason = t.evaluatedWithRules?._reason;
              const isScored = t.evaluationStatus === 'scored';
              return (
                <tr key={t._id}>
                  <td>
                    <div className="font-semibold text-white">
                      {m ? `${m.homeTeamName} vs ${m.awayTeamName}` : '–'}
                    </div>
                    {m?.mfleagueRoundName && (
                      <div className="text-xs text-white/40 mt-0.5 uppercase tracking-wide">{m.mfleagueRoundName}</div>
                    )}
                  </td>
                  <td className="font-bold tabular-nums">{t.tipHome != null ? `${t.tipHome}:${t.tipAway}` : '–'}</td>
                  <td className="tabular-nums text-white/70">
                    {result?.home != null ? `${result.home}:${result.away}` : '–'}
                  </td>
                  <td className="text-right font-black text-primary-light tabular-nums">{t.points ?? '–'}</td>
                  <td className="hidden sm:table-cell text-white/55 text-sm">{reason ? (REASON_LABELS[reason] || reason) : '–'}</td>
                  <td>
                    <span className={`status-pill ${isScored ? 'status-pill--scored' : 'status-pill--pending'}`}>
                      {EVALUATION_LABELS[t.evaluationStatus] || t.evaluationStatus}
                    </span>
                  </td>
                </tr>
              );
            })}
            {tips.length === 0 && !error && (
              <tr>
                <td colSpan={6} className="text-center text-white/50 py-12">
                  Noch keine Tipps abgegeben.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TippspielMyTips;
